module.exports = __webpack_public_path__ + "assets/img/11_474.5d545006.jpg";